/*
 * @Author: bbqin
 * @Date: 2021-09-06 09:53:45
 * @LastEditTime: 2022-10-31 17:14:47
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\InsertTable\toolCell.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { Tooltip as NCTooltip } from '@platform/base';
import Hyperlink from '../Hyperlink';
const { getHyperlinkValue } = Hyperlink;

class ToolCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipStatus: false
        };
    }

    componentWillUnmount() {
        this.cellDom = null;
    }

    handleMouseOver = () => {
        if (this.cellDom) {
            let { tipStatus } = this.state;
            if (this.cellDom.scrollWidth > this.cellDom.clientWidth && tipStatus === false) {
                this.setState({ tipStatus: true });
            }
            if (this.cellDom.scrollWidth <= this.cellDom.clientWidth && tipStatus === true) {
                this.setState({ tipStatus: false });
            }
        }
    };

    render() {
        let { context, multipleRowCell, isLineAll, hyperlinkParams = {} } = this.props;

        return (
            <NCTooltip
                placement="top"
                overlay={this.state.tipStatus ? context : ''}
                className="tooltip-word-color"
                delay={1}
                inverse
            >
                <span
                    onMouseOver={this.handleMouseOver}
                    className={classnames(
                        { textLineAll: !multipleRowCell },
                        { noTextLineAll: !isLineAll },
                        { "hyperlink-cell-text": hyperlinkParams.hyperlinkflag }
                    )}
                    ref={dom => {
                        this.cellDom = ReactDOM.findDOMNode(dom);
                    }}
                >
                    {hyperlinkParams.hyperlinkflag ? <Hyperlink
                        datatype={hyperlinkParams.datatype}
                        hyperlinkflag={hyperlinkParams.hyperlinkflag}
                        hyperlinktype={hyperlinkParams.hyperlinktype}
                        hyperlinkname={hyperlinkParams.hyperlinkname}
                        hyperlinkurl={hyperlinkParams.hyperlinkurl}
                        value={context}
                        browse={true}
                        pageId={hyperlinkParams.pageId}
                        areaCode={hyperlinkParams.areaCode}
                        attrCode={hyperlinkParams.attrCode}
                        dataId={hyperlinkParams.dataId}
                        className={'hyper-link'}
                    >
                        {context ? context : <span>&nbsp;</span>}
                    </Hyperlink> : (context ? context : <span>&nbsp;</span>)}
                </span>
            </NCTooltip>
        );
    }
}

export default ToolCell;
